import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ResponseData } from './qna.model';

export const selectInstructorQNAState = createFeatureSelector<ResponseData>('instructorQNA');

export const selectInstructorQNA = createSelector(selectInstructorQNAState, (entities) => entities);
